const DialogNavIcon = ({
  className = 'stroke-green-800'
}: {
  className?: string
  fill?: string
}) => (
  <svg
    width='24'
    height='27'
    viewBox='0 0 24 27'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12 19.916H18C19.657 19.916 21 18.4326 21 16.6024V7.76621C21 5.93601 19.657 4.45264 18 4.45264H6C4.343 4.45264 3 5.93601 3 7.76621V16.6024C3 18.4326 4.343 19.916 6 19.916H7.5V23.2296L12 19.916Z'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export default DialogNavIcon
